import { CarrotPlansPaths } from "#/utils/Paths"
import { useLocation } from "react-router"

const ROUTING_FLOW_PATH_MAP: Record<string, CarrotPlansPaths> = {
  [CarrotPlansPaths.ENROLLMENT]: CarrotPlansPaths.ENROLLMENT,
  [CarrotPlansPaths.CASE_RATE_RENEWAL]: CarrotPlansPaths.CASE_RATE_RENEWAL,
  [CarrotPlansPaths.CHECK_IN_EXPERIENCE]: CarrotPlansPaths.CHECK_IN_EXPERIENCE,
  [CarrotPlansPaths.JOURNEY_CHANGE]: CarrotPlansPaths.JOURNEY_CHANGE
}

/**
 * Hook-based utility to get the current routing flow path using React Router's useLocation.
 * Use this in React components instead of getCurrentRoutingFlowPath.
 */
function useRoutingFlowPath(): CarrotPlansPaths | null {
  const { pathname } = useLocation()
  return ROUTING_FLOW_PATH_MAP[pathname] ?? null
}

export function useIsInitialRouting(): boolean {
  const routingFlowPath = useRoutingFlowPath()

  return routingFlowPath === CarrotPlansPaths.ENROLLMENT || routingFlowPath === null
}
